// Third-party library imports.
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

// Local repo imports.
import { EMPTY_STRING } from '../../../constants/Constants';
import '../CheckboxPalette.scss';
import { isEmpty } from '../../../utils/helper';
class PaletteName extends React.PureComponent {
  render() {
    const {
      name,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "palette-name"
    }, children, /*#__PURE__*/React.createElement("div", {
      className: cx('palette-words-overflow-control', {
        'palette-name-extend': isEmpty(children)
      })
    }, name));
  }
}
PaletteName.propTypes = {
  name: PropTypes.string
};
PaletteName.defaultProps = {
  name: EMPTY_STRING
};
export default PaletteName;